var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dragDialog", rawName: "v-dragDialog" }],
      attrs: {
        title: "呼吸训练日志",
        visible: _vm.formVisible,
        width: "1100px",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: { close: _vm.close }
    },
    [
      _c(
        "el-form",
        [
          _c("el-form-item", { attrs: { label: "训练完成情况" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.format.completeLevelsFormat(_vm.response.CompleteLevel)
                ) +
                " "
            )
          ]),
          _c("el-form-item", { attrs: { label: "训练后疲劳程度" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.format.fatigueLevelsFormat(_vm.response.FatigueLevel)
                ) +
                " "
            )
          ]),
          _c("el-form-item", { attrs: { label: "训练时呼吸器实际气压" } }, [
            _vm._v(" " + _vm._s(_vm.response.CMH2O) + " ")
          ]),
          _c("el-form-item", { attrs: { label: "训练总时长" } }, [
            _vm._v(" " + _vm._s(_vm.response.Minutes) + "分钟 ")
          ]),
          _c("el-form-item", { attrs: { label: "本次训练动作数量" } }, [
            _vm._v(" " + _vm._s(_vm.response.CompleteTotal) + "个 ")
          ]),
          _c("el-form-item", { attrs: { label: "训练后是否感到获得提升" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.format.improveFeelsFormat(_vm.response.ImproveFeel)
                ) +
                " "
            )
          ]),
          _c("el-form-item", { attrs: { label: "练中是否有较难完成的动作" } }, [
            _vm._v(" " + _vm._s(_vm.response.Difficults) + " ")
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "训练中是否有存在困惑的动作" } },
            [_vm._v(" " + _vm._s(_vm.response.Confusions) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }